import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, mergeProps as _mergeProps, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
    key: 0,
    class: "themeModal-header"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
import { computed, ref, onBeforeMount, watch, nextTick, useSlots } from 'vue';
import ThemeButton from '../Button/Button.vue';
import { freezeWindowScroll, unfreezeWindowScroll } from '../../shared';
const __default__ = {
    inheritAttrs: false,
};
export default /*#__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'Modal', props: {
        title: {},
        wcaTitle: {},
        bodyHtml: {},
        bodyDOM: {},
        actions: {},
        dismissible: { type: Boolean, default: true },
        classes: {},
        afterDismissed: {}
    }, emits: ['shown', 'dismissed'], setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const slots = useSlots();
        const bodyEl = ref();
        const contentEl = ref();
        const footerEl = ref(null);
        const bodyDOMContainerEl = ref(null);
        const shown = ref(false);
        let response;
        __expose({
            show,
            dismiss,
        });
        onBeforeMount(() => {
            let themeModalContainer = document.getElementById('themeModalContainer');
            if (!themeModalContainer) {
                const themeModalContainer = document.createElement('div');
                themeModalContainer.id = 'themeModalContainer';
                themeModalContainer.classList.add('themeModalContainer');
                document.body.appendChild(themeModalContainer);
            }
        });
        watch(() => props.bodyDOM, (newVal, oldVal) => {
            var _a;
            if (newVal && newVal !== oldVal) {
                (_a = bodyDOMContainerEl.value) === null || _a === void 0 ? void 0 : _a.appendChild(newVal);
            }
        });
        const emit = __emit;
        const wcaTitle = computed(() => {
            return props.wcaTitle || props.title;
        });
        function show() {
            shown.value = true;
            nextTick(() => {
                var _a;
                if (props.bodyDOM) {
                    (_a = bodyDOMContainerEl.value) === null || _a === void 0 ? void 0 : _a.appendChild(props.bodyDOM);
                }
            });
        }
        function dismiss() {
            shown.value = false;
        }
        function onEscape(event) {
            if (!props.dismissible) {
                event.preventDefault();
            }
        }
        function onReveal() {
            var _a;
            const layer = parseInt(document.body.dataset.ctmodalLayer || '') || 0;
            document.body.setAttribute('data-ctmodal-layer', (layer + 1).toString());
            (_a = document.getElementById('siteContent')) === null || _a === void 0 ? void 0 : _a.setAttribute('inert', 'inert');
            freezeWindowScroll();
            emit('shown');
        }
        function onConceal() {
            var _a;
            let layer = parseInt(document.body.dataset.ctmodalLayer || '');
            if (layer) {
                layer--;
            }
            if (!layer) {
                document.body.removeAttribute('data-ctmodal-layer');
                (_a = document.getElementById('siteContent')) === null || _a === void 0 ? void 0 : _a.removeAttribute('inert');
                unfreezeWindowScroll();
            }
            else {
                document.body.setAttribute('data-ctmodal-layer', layer.toString());
            }
            emit('dismissed', response);
            typeof props.afterDismissed === 'function' && props.afterDismissed(response);
        }
        function handleActionButtonClick(action, event) {
            if (!action.handler || action.handler === 'dismiss' && props.dismissible) {
                dismiss();
            }
            else if (typeof action.handler === 'function') {
                const resp = action.handler(event);
                if (action.handlerBehavior === 'dismiss') {
                    response = resp;
                    dismiss();
                }
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "#themeModalContainer" }, [
                _createVNode(_Transition, {
                    name: "reveal",
                    onBeforeEnter: _cache[2] || (_cache[2] = ($event) => (onReveal())),
                    onAfterLeave: _cache[3] || (_cache[3] = ($event) => (onConceal()))
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            (shown.value)
                                ? (_openBlock(), _createElementBlock("div", _mergeProps({
                                    key: 0,
                                    class: ["themeModal", _ctx.classes],
                                    role: "dialog",
                                    "aria-modal": "true",
                                    "aria-label": wcaTitle.value,
                                    onKeydown: _withKeys(onEscape, ["esc"])
                                }, _ctx.$attrs), [
                                    _createElementVNode("div", {
                                        class: "themeModal-backdrop",
                                        onClick: _cache[0] || (_cache[0] = () => _ctx.dismissible && dismiss())
                                    }),
                                    _createElementVNode("div", {
                                        class: "themeModal-content",
                                        ref_key: "contentEl",
                                        ref: contentEl
                                    }, [
                                        (_ctx.title || _unref(slots).title)
                                            ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                                                (_ctx.title)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        innerHTML: _ctx.title
                                                    }, null, 8, _hoisted_3))
                                                    : _createCommentVNode("", true),
                                                _renderSlot(_ctx.$slots, "title")
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                            class: "themeModal-body",
                                            ref_key: "bodyEl",
                                            ref: bodyEl
                                        }, [
                                            (_ctx.bodyHtml)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    innerHTML: _ctx.bodyHtml
                                                }, null, 8, _hoisted_4))
                                                : _createCommentVNode("", true),
                                            (_ctx.bodyDOM)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    ref_key: "bodyDOMContainerEl",
                                                    ref: bodyDOMContainerEl
                                                }, null, 512))
                                                : _createCommentVNode("", true),
                                            _renderSlot(_ctx.$slots, "default")
                                        ], 512),
                                        ((_a = _ctx.actions) === null || _a === void 0 ? void 0 : _a.length)
                                            ? (_openBlock(), _createElementBlock("footer", {
                                                key: 1,
                                                class: "themeModal-footer",
                                                ref_key: "footerEl",
                                                ref: footerEl
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                                                    return (_openBlock(), _createBlock(ThemeButton, {
                                                        key: (action.title || '') + (action.icon || '') + (action.iconAfter || ''),
                                                        title: action.title,
                                                        icon: action.icon,
                                                        "icon-after": action.iconAfter,
                                                        fill: action.fill || 'outline',
                                                        disabled: action.disabled,
                                                        color: action.color,
                                                        state: action.state,
                                                        size: "small",
                                                        onClick: ($event) => (handleActionButtonClick(action, $event))
                                                    }, null, 8, ["title", "icon", "icon-after", "fill", "disabled", "color", "state", "onClick"]));
                                                }), 128))
                                            ], 512))
                                            : _createCommentVNode("", true),
                                        (_ctx.dismissible)
                                            ? (_openBlock(), _createBlock(ThemeButton, {
                                                key: 2,
                                                class: "themeModal-closeBtn",
                                                "wca-title": "Stäng",
                                                icon: "times",
                                                color: "white",
                                                fill: "solid",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (dismiss()))
                                            }))
                                            : _createCommentVNode("", true)
                                    ], 512)
                                ], 16, _hoisted_1))
                                : _createCommentVNode("", true)
                        ];
                    }),
                    _: 3
                })
            ]));
        };
    } }));
